<template>
  <div id="application-layout">
    <keep-alive>
      <!-- 需要缓存的视图组件 -->
      <router-view v-if="$route.meta.keepAlive"> </router-view>
    </keep-alive>

    <!-- 不需要缓存的视图组件 -->
    <router-view v-if="!$route.meta.keepAlive"> </router-view>
  </div>
</template>

<script>
export default {
  name: 'UserApplicationLayout',
  data() {
    return {}
  },
  created() {}
}
</script>

<style lang="less" scoped>
#application-layout {
  height: 100vh;
  background-color: #efefef;
}
</style>
